import { adobeLaunch } from "vg-fas-adobe-launch";

let self = {};
self.defaultPageData = {
	siteSection1: "tax-center",
	pageTemplate: "Simple"
};

self.trackPageLoad = (is404, siteSection, subPage) => {
	let pageData = Object.assign({}, self.defaultPageData);
	pageData.siteSection2 = siteSection;
	pageData.subPage1 = subPage;
	pageData.is404 = is404;
	adobeLaunch.initializePage(pageData);
};

self.trackSearchConducted = (searchTerm) => {
	let searchInfo = {
		searchType: "tax center"
	};
	searchInfo.searchTermEntered = searchTerm;
	adobeLaunch.trackSearchConducted(searchInfo);
};

self.trackDownload = (fileName, fileType) => {
	adobeLaunch.trackContentDownloaded(`${fileType}:${fileName}`);
};

export default self;
